import CoachToolsLayout from './CoachToolsLayout';

export default CoachToolsLayout;
